import React from 'react';
import Type from 'prop-types';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import styles from './RadioGroupFilter.module.css';

export const RadioGroupFilter = (props) => {
  const {
    label,
    options,
    field,
    form: { setFieldValue },
    onChange,
  } = props;

  const handleChange = (event) => {
    setFieldValue(field.name, event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange(event.target.value);
    }
  };

  const renderRadioButton = (option) => {
    return (
      <FormControlLabel
        key={option.id}
        value={option.id}
        control={<Radio />}
        label={option.name}
      />
    );
  };

  return (
    <FormControl>
      <FormLabel id="radio-group-filter-label">
        <span className={styles.title}>{label}</span>
      </FormLabel>
      <RadioGroup
        aria-labelledby="radio-group-filter-label"
        name="radio-group-filter"
        value={field.value}
        onChange={handleChange}
      >
        {options.map((option) => renderRadioButton(option))}
      </RadioGroup>
    </FormControl>
  );
};

RadioGroupFilter.propTypes = {
  label: Type.string.isRequired,
  options: Type.arrayOf(
    Type.shape({
      id: Type.string,
      name: Type.string,
    }),
  ).isRequired,
  field: Type.shape({
    name: Type.string.isRequired,
    value: Type.string.isRequired,
  }).isRequired,
  form: Type.shape({
    setFieldValue: Type.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    touched: Type.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    errors: Type.object,
  }).isRequired,
  onChange: Type.func.isRequired,
};
